import ResultItem from "./ResultItem";
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css'

const style ={
    background: "#2D2D2D",
    borderRadius: "8px",
    padding: "20px",
    margin: "20px 0px",
};

const resultItem ={
    display: 'flex',
    flexDirection: 'row',
    gap: '25px',
}

const styleP={
    color: '#fff',
    fontWeight: '600',
    fontSize: '20px',
}



const Result = ({data}) => {
    return (
        <>
            <div style={style}>
                <div>
                    <p style={styleP}>Select Some User From Oxygen Video Feed Result For The next round</p>
                </div>
                <div style={resultItem}>
                    <OwlCarousel className='owl-theme' items={3} loop autoplay>
                        {
                            data && data.length > 0 && data.map((item)=>(
                                <div className='item'>
                                    <ResultItem userInfo={item.userInfo} comment={item.comment} selectStatus={item.selectStatus} />
                                </div>
                            ))
                        }
                    </OwlCarousel>
                </div>
            </div>

        </>
    );
};

export default Result;